import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import Media from './components/Media';
import About from './components/About';
import Index from './components/Index';
import FAQ from './components/FAQ';
import Carousel from './components/Carousel';
import AppModule from './components/AppModule';
import Features from './components/Features';
import Updates from './components/Updates';
import Cards from './components/Cards';
import Contact from './components/Contact';
import Comments from './components/Comments';
import Topics from './components/Topics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-950">
      <Header />
      <main>
        <Hero />
        <Ranking />
        <Media />
        <About />
        <Index />
        <FAQ />
        <Carousel />
        <AppModule />
        <Features />
        <Updates />
        <Cards />
        <Contact />
        <Comments />
        <Topics />
      </main>
      <Footer />
    </div>
  );
}